import * as ActionTypes from "./actionTypes";
import * as urls from "../common/urls";
import axios from "axios";


export function generateStockWithPrice(params) {
    const request = axios.post(urls.PRICES_URL, params);
    return { type: ActionTypes.GENERATE_STOCK_WITH_PRICE, payload: request };
}

export function ResetSelectedStock(specialPrice, originalPrice) {
    return {
        type: ActionTypes.RESET_SELECTED_STOCK,
        payload: new Promise(function (resolve, reject) { resolve({ specialPrice: specialPrice, originalPrice: originalPrice }); })
    };

    return { type: ActionTypes.RESET_SELECTED_STOCK, payload: request };
}